import _http_v1 from '@packs/http_requests/_http_v1'

export default {
    getDaeeRadarStates: async function(limit = 20){
        return _http_v1.request('radars/1/last_images', 'GET', {limit: limit, with_link:true, path_suffix: 'cappi_24h'}).then(images=>{
            let images_list = images.json
            const imagesOrder = images =>{
                return images.sort((a,b)=> toDate(a.key.replace('daee/cappi_24h/', '').replace('.png', '')).getTime() - toDate(b.key.replace('daee/cappi_24h/', '').replace('.png', '')).getTime())
            }
            const toDate  = text =>{
                return new Date(`${text.substring(0,4)}-${text.substring(4,6)}-${text.substring(6,8)} ${text.substring(8,10)}:${text.substring(10,12)}`)
            }

            const normalizeTitle = title =>{
                title = title.replace('daee/cappi_24h/', '').replace('.png', '')
                return `<span>${moment(title, "YYYYMMDDHHmm").subtract(3, 'hours').format("DD-MM-YYYY HH:mm")}</span>`
            }
    
            if(images_list.length > 1){
                images_list = imagesOrder(images_list) //ordenando
            }
            
            //criando states
            return images_list.map(image=>{
                return {
                    key: image.key,
                    title: normalizeTitle(image.key),
                    content: image.url
                }
            })
        })
    }
}